/* eslint-disable no-debugger */
import axios from 'axios'

axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';

export function postRequest(url,data,bearerToken='') {
    return axios.post(url,data,
    { 
        crossdomain: true,
        headers:{
            'Access-Control-Allow-Origin' : '*',
			'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
			'Authorization' : `Bearer ${bearerToken}`
        }
   })
}
export function putRequest(url,data,bearerToken='') {
	return axios.put(url,data,
	{ 
		crossdomain: true,
		headers: {
			'Access-Control-Allow-Origin' : '*',
			'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
			'Authorization' : `Bearer ${bearerToken}`
		}
	})
}

export function getRequest(url, responseType,bearerToken='') 
{
	return axios.get(url,
		{ 
			crossdomain: true,
			headers: {
				'Access-Control-Allow-Origin' : '*',
				'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
				'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private',
				'Authorization' : `Bearer ${bearerToken}`
			},
			responseType: responseType != undefined ? responseType: 'json'
		})
}


// WEBPACK FOOTER //
// ./src/utils/functions/httpRequest.js